import {
  listen,
  sendLocal,
  sidebarStateMessage,
  isSidebarStateRequestMessage,
  isData,
} from "@sinch/bus";
import { useEffect } from "react";

export const useLayoutHandler = (isDisabled: boolean) => {
  useEffect(() => {
    const sidebarState = {
      isDisabled,
    };
    sendLocal(sidebarStateMessage(sidebarState));
    const unsub = listen((m) => {
      if (isData(m)) {
        sendLocal(sidebarStateMessage(sidebarState));
      }
    }, isSidebarStateRequestMessage);

    return unsub;
  }, [isDisabled]);
};
